export default "__VITE_ASSET__ES3ihCuk__"